/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons/index.js";
import BeneAccountDetailsPopup from "../../../../components/Accounts/BeneAccount/BeneAccountDetailsPopup/index.jsx";
import BeneAccountViewAllPopup from "../../../../components/Accounts/BeneAccount/BeneAccountViewAllPopup/index.jsx";
import Loader from "../../../../components/Loader/Index";
import CommonAccountApprovalCard from "../../../../components/_utils/CommonAccountApprovalCard/index.jsx";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect/index.jsx";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup/index.jsx";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput/index.jsx";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import PaginationComponent from "../../../../components/_utils/PaginationComponent";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast/index.jsx";
import {
  addNewLabel,
  beneBankLookUp,
  beneCategories,
  beneDeniedAccount,
  beneRequiredApproval,
  beneWaitingApproved,
  removeNewLabel,
} from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { beneTxnMultiDeniedApproval } from "../../../../redux/features/beneficiary/beneTxnViewAccData/beneTxnViewAccData";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import { schedulesTxnReject } from "../../../../redux/features/scheduleTransaction";
import {
  beneLookUp,
  viewAccountDetail,
} from "../../../../redux/features/verifyPAN/verifyPAN";
import accountNameStandardised from "../../../../utils/accountNamestandardised.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../../utils/configurationProvider.js";
import BeneficiaryTransactionViewall from "../../../Transactions/BeneficiaryTransactions/BeneficiaryTransactionViewall/index.jsx";
import ScheduleBeneficiaryTransactionViewSchedules from "../../../Transactions/ScheduleBeneficiaryTransactions/ScheduleBeneficiaryTransactionViewSchedules/index.jsx";
import "./index.css";

const BeneficiaryAcountApproval = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const filterRef = useRef(null);
  const sidebarRef = useRef(null);
  const dropdownRef = useRef(null);
  const searchBarRefAcc = useRef(null);
  const sidebarButtonRef = useRef(null);
  const searchBarRefAccSecond = useRef(null);
  const labelActionDispatchedRef = useRef(false);
  const [remPan, setRemPan] = useState("");
  const [isIfsc, setIsIfsc] = useState("");
  const [labels, setLabels] = useState([]);
  const [active, setActive] = useState("");
  const [lebalid, setlableid] = useState([]);
  const [remIFSC, setRemIFSC] = useState("");
  const [loading, setLoading] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [mainData, setMainData] = useState([]);
  const [pageSize, setPageSize] = useState(50);
  const [panNumber, setPanNumber] = useState("");
  const [deniedId, SetdeniedId] = useState(null);
  const [inputData, setInputData] = useState([]);
  const [remAccount, setRemAccount] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isFocused, setIsFocused] = useState(false);
  const [allAccounts, setAllAccounts] = useState([]);
  const [accountName, setAccountName] = useState("");
  const [activeType, setActiveType] = useState("pan");
  const [showLoader, setShowLoader] = useState(false);
  const [accountNumber, setAccountNumber] = useState("");
  const [declineReason, setDeclineReason] = useState("");
  const [associateType, setAssociateType] = useState("");
  const [endDateFilter, setEndDateFilter] = useState("");
  const [showCategory, setShowCategory] = useState(false);
  const [isDrawerOpen, setisDrawerOpen] = useState(false);
  const [searchUserText, setSearchUserText] = useState("");
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [currentCategory, setCurrentCategory] = useState("");
  const [LabelSearchText, setLabelSearchText] = useState([]);
  const [accumulatedData, setAccumulatedData] = useState([]);
  const [startDateFilter, setStartDateFilter] = useState("");
  const [BeneTxnDetailsId, SetBeneTxnDetailsId] = useState("");
  const [showRejectPopup, setShowRejectPopup] = useState(false);
  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);
  const [openBeneAssociate, setOpenBeneAssociate] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  const [allBeneTxnAccountsLoading, setAllBeneTxnAccountsLoading] =
    useState(false);
  const [showScheduleTxnPopup, setShowScheduleTxnPopup] = useState(false);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const dropdownOptions =
    window.innerWidth < 1600
      ? [50, 100]
      : window.innerWidth < 2560
        ? [50, 100]
        : [50, 100];
  const [selectedValue, setSelectedValue] = useState(dropdownOptions[0]);
  const [whichBtnClicked, setWhichBtnClicked] = useState({});

  const [isalertPopup, setAlertPopUp] = useState(false);
  const [pendingNavTarget, setPendingNavTarget] = useState(null);

  const services = useSelector((state) => state.refreshToken.services);
  const { beneRequiredApprovalData } = useSelector(
    (state) => state.beneAllVerification,
  );
  const { beneWaitingApprovalData } = useSelector((state) => {
    return state.beneAllVerification;
  });
  const { beneDeniedApprovalLoading } = useSelector(
    (state) => state.beneAllVerification,
  );

  const { schedulesTxnViewAllData, schedulesTxnViewAllLoading } = useSelector(
    (state) => state?.schedulesTxnSlice,
  );

  const { beneTxnViewAllAccLoading, beneTxnViewAllAccData } = useSelector(
    (state) => state?.beneTxnViewAccData,
  );

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  const updateAllAccounts = (updatedAccounts) => {
    setAllAccounts(updatedAccounts);
  };

  const [associatePopupDate, setAssociatePopupDate] = useState({
    panNumber: "",
    ifscCode: "",
    accNumber: "",
    accId: "",
    accName: "",
  });

  const hasAnyFilter =
    Boolean(currentCategory?.length) ||
    Boolean(LabelSearchText?.length) ||
    Boolean(accountNumber?.length) ||
    Boolean(panNumber?.length) ||
    Boolean(searchUserText?.length) ||
    (startDateFilter !== "" &&
      endDateFilter !== "" &&
      startDateFilter !== GlobalConfiguration.lengthCheckZero &&
      endDateFilter !== GlobalConfiguration.lengthCheckZero &&
      !isNaN(Number(startDateFilter)) &&
      !isNaN(Number(endDateFilter))) ||
    Boolean(isIfsc) ||
    Boolean(searchUserTextDebounce?.length);

  const noTransactionsFromAPI =
    !allBeneTxnAccountsLoading &&
    mainData &&
    mainData.total_count === GlobalConfiguration.lengthCheckZero &&
    !hasAnyFilter;

  const noResultsAfterFilter =
    !allBeneTxnAccountsLoading &&
    accumulatedData?.length === GlobalConfiguration.lengthCheckZero &&
    hasAnyFilter;

  const handleInputChange = (event) => {
    let value = event?.target?.value;

    value = value.replace(/[^a-zA-Z0-9\s]/g, "");
    value = value.replace(/^\s+/, "");

    value = value.replace(/\s{2,}/g, " ");

    value = value.slice(0, 150);

    setDeclineReason(value);
  };

  const fetchDataBeneAccountApproval = async () => {
    let response;
    let data = [];

    switch (active) {
      case "Category":
        response = await dispatch(
          beneCategories({ search_string: searchUserTextDebounce }),
        );
        data = response?.payload?.categories?.map((itm) => {
          return {
            id: itm.name,
            Category: itm.name,
            Description: itm?.description || "Not given",
          };
        });
        setInputData(data);
        break;
      case "Labels":
        data = labels
          ?.filter((itm) => {
            if (itm.includes(searchUserTextDebounce)) return true;
            else return false;
          })
          ?.map((val) => {
            return { id: val, Label: val };
          });
        setInputData(data);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (active?.length) {
      fetchDataBeneAccountApproval();
    }
  }, [active]);

  const fetchData = async () => {
    try {
      setAllBeneTxnAccountsLoading(true);
      let queryParams = {
        page_no: currentPage,
        page_size: pageSize,
        type_of_account: "beneficiary",
      };
      if (currentCategory !== "") {
        queryParams.categoryName = currentCategory;
      }
      if (
        startDateFilter !== "" &&
        endDateFilter !== "" &&
        startDateFilter !== 0 &&
        endDateFilter !== 0 &&
        !isNaN(Number(startDateFilter)) &&
        !isNaN(Number(endDateFilter))
      ) {
        queryParams.start_date = startDateFilter;
        queryParams.end_date = endDateFilter;
      }
      if (accountNumber !== "") {
        queryParams.bank_account_no = accountNumber;
      }
      if (currentCategory !== "") {
        queryParams.categoryName = currentCategory;
      }

      if (panNumber !== "") {
        queryParams.pan = panNumber;
      }
      if (searchUserText !== "") {
        queryParams.search_string = searchUserText;
      }
      if (LabelSearchText?.length !== GlobalConfiguration.lengthCheckZero) {
        queryParams.labels = LabelSearchText;
      }
      if (isIfsc !== "") {
        queryParams.ifsc = isIfsc;
      }

      const response = await dispatch(beneRequiredApproval(queryParams));

      const newData = (response?.payload?.beneficiary_accounts || []).map(
        (account) => ({
          ...account,
          loading: false,
          error: "false",
          message: "",
        }),
      );

      setAllAccounts(() => [...newData]);
      setMainData(response?.payload);
      setLabels(response?.payload?.summary?.available_labels);
      const rawData = response?.payload?.beneficiary_accounts || [];
      setAccumulatedData(rawData);
    } catch (error) {
      console.error("Error fetching beneficiary accounts:", error);
    } finally {
      setAllBeneTxnAccountsLoading(false);
    }
  };

  const handleDateChange = (date) => {
    if (date) {
      const [start, end] = date;
      setStartDateFilter(convertDate(start));
      setEndDateFilter(convertDate(end));
    } else {
      setStartDateFilter("");
      setEndDateFilter("");
    }
  };

  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    fetchData();
  }, [
    dispatch,
    currentPage,
    pageSize,
    startDateFilter,
    endDateFilter,
    accountNumber,
    accountName,
    panNumber,
    searchUserText,
    isIfsc,
    currentCategory,
    LabelSearchText,
    markerData,
  ]);

  const handleSelect = (value) => {
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(Number(currentPage));
    toggleDropdown();
  };

  const filteredData = accumulatedData;

  const handleOpenPopup = (id) => {
    setShowPopup(true);
    SetdeniedId(id);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    setDeclineReason("");
  };

  const handleClose = () => {
    setIsLabelPopupOpen(false);
    if (labelActionDispatchedRef.current) {
      fetchData();
      labelActionDispatchedRef.current = false;
    }
  };

  const handleCloseModal = () => {
    if (isalertPopup) return;
    setOpenBeneAssociate(false);
  };

  const onClose = () => {
    setShowRejectPopup(false);
  };

  const handleApprovalToastSuccess = () => {
    CommonToast({
      text: "Account approved successfully.",
      icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
      variant: "var(--success)",
      btnProps: {
        isDisabled: false,
        enabledTextColor: "var(--text-primary)",
        enabledBgColor: "var(--primary-bg)",
      },
    });
  };

  const handleApproval = async (id) => {
    setLoading((prevLoadingStates) => ({
      ...prevLoadingStates,
      [id]: true,
    }));
    UniversalRefreshToast("approvalaccountsRefresh");

    const data = await dispatch(beneWaitingApproved(id));

    if (
      data?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration.lengthCheckZero
    ) {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "BAAccount",
        },
      });
      return;
    }

    let errorMessage = "";
    if (data) {
      const errors = data?.payload?.errors;

      if (errors?.beneficiary_account?.[0]) {
        errorMessage = errors.beneficiary_account[0];
      } else if (errors?.bank_account_number?.[0]) {
        errorMessage = errors.bank_account_number[0];
      } else if (!data?.payload?.status) {
        errorMessage = errors?.category?.[0];
      } else {
        errorMessage = "An unknown error occurred.";
      }
    }

    if (data) {
      const updatedData = allAccounts.map((item) => {
        if (item.id === id) {
          let lifecycleStatus = "";

          if (data.payload.status === true) {
            lifecycleStatus = "Approved";
          }
          if (data.payload.status === false) {
            lifecycleStatus = "error";
          }

          let message = "";
          if (data.payload.status === false) {
            const errors = data?.payload?.errors;
            if (errors?.beneficiary_account?.[0]) {
              message = errors.beneficiary_account[0];
            } else if (data?.payload?.errors === "false") {
              message = errors?.category?.[0];
            } else if (errors?.bank_account_number?.[0]) {
              message = errors.bank_account_number[0];
            }
          }

          return {
            ...item,
            approval_status:
              item.approval_status === "pending" ? lifecycleStatus : "pending",
            error:
              item.error === "false" && data?.payload.status === false
                ? "true"
                : "false",
            message:
              item.message === "" && data.payload.status === false
                ? message
                : "",
          };
        }

        return item;
      });

      setAllAccounts(updatedData);

      if (data?.payload.status === false) {
        CommonToast({
          text: errorMessage,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    }

    setTimeout(() => {
      setLoading((prevLoadingStates) => ({
        ...prevLoadingStates,
        [id]: false,
      }));
    }, IntervalConfiguration.intervalExtraLarge);

    setTimeout(() => {
      if (data.payload.status === true) {
        handleApprovalToastSuccess();
      }
    }, IntervalConfiguration.intervalExtraLarge);
  };

  const BeneAccountMoreDetailsPopup = async (id) => {
    SetBeneTxnDetailsId(id);
    setisDrawerOpen(!isDrawerOpen);
  };
  const closeBeneAccountDetailModal = () => {
    setisDrawerOpen(false);
  };

  const openAssociatedAccountsFound = (ifsc_code, acc_no, pan_no, id) => {
    dispatch(beneLookUp({ pan_number: pan_no }));
    dispatch(
      beneBankLookUp({
        ifsc: ifsc_code,
        bank_account_no: acc_no,
      }),
    );
    setAssociatePopupDate((prev) => {
      return {
        ...prev,
        ifscCode: ifsc_code,
        accNumber: acc_no,
        accId: id,
        panNumber: pan_no,
      };
    });

    setRemPan(pan_no);
    setOpenBeneAssociate(true);
  };

  const openTxnPopup = (id, acc_Name) => {
    setAssociatePopupDate((prev) => {
      return {
        ...prev,
        accId: id,
        accName: acc_Name,
      };
    });
  };

  const handleCardClick = (targetPath) => {
    setPendingNavTarget(targetPath);
    setAlertPopUp(true);
  };

  const handleLeaveConfirm = () => {
    setAlertPopUp(false);
    setOpenBeneAssociate(false);
    if (pendingNavTarget) {
      navigate(pendingNavTarget);
    }
    setPendingNavTarget(null);
  };

  const handleAlertCancel = () => {
    setAlertPopUp(false);
    setPendingNavTarget(null);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchBarRefAcc.current &&
        !searchBarRefAcc.current.contains(event.target) &&
        searchBarRefAccSecond.current &&
        !searchBarRefAccSecond.current.contains(event.target)
      ) {
        setShowSearchBar(false);
      }

      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }

      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        sidebarButtonRef.current &&
        !sidebarButtonRef.current.contains(event.target)
      ) {
        setIsSidebarOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleClearFilters = () => {
    setAllBeneTxnAccountsLoading(true);

    setStartDateFilter("");
    setEndDateFilter("");
    setShowSearchBar(false);
    setCurrentCategory("");
    setPanNumber("") ||
      setAccountNumber("") ||
      setIsIfsc("") ||
      setLabelSearchText("");
    setSearchUserTextDebounce("");
    setSearchUserText("");
  };

  // Beneficiary Txn & Schedule beneficiary txn check
  const handleRejectTransactionChecker = async (id, AccountIdData) => {
    setShowPopup(false);

    const accountInfo = await dispatch(viewAccountDetail({ id: deniedId }));
    if (
      accountInfo?.payload?.beneficiary_accounts?.[0]?.pending_transactions ===
        "Y" &&
      (accountInfo?.payload?.beneficiary_accounts?.[0]
        ?.pending_scheduled_transactions === "Y" ||
        accountInfo?.payload?.beneficiary_accounts?.[0]
          ?.pending_scheduled_transactions === "N")
    ) {
      setShowRejectPopup(true);
    } else if (
      accountInfo?.payload?.beneficiary_accounts?.[0]?.pending_transactions ===
        "N" &&
      accountInfo?.payload?.beneficiary_accounts?.[0]
        ?.pending_scheduled_transactions === "Y"
    ) {
      setShowScheduleTxnPopup(true);
    } else {
      handleConfirm(id, AccountIdData);
    }
  };

  const handleConfirm = async (id, AccountIdData) => {
    setShowLoader(true);

    UniversalRefreshToast("accountsRefresh");

    if (!beneDeniedApprovalLoading || beneDeniedApprovalLoading === null) {
      const result = await dispatch(beneDeniedAccount({ id, AccountIdData }));

      await new Promise((resolve) =>
        setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
      );

      if (result?.payload?.status === false) {
        let error_msg = "";

        if (result?.payload?.errors?.beneficiary_account?.[0]) {
          error_msg = result?.payload?.errors?.beneficiary_account[0];
        } else if (result?.payload?.errors?.bank_account_number?.[0]) {
          error_msg = result?.payload?.errors?.bank_account_number[0];
        } else if (!result?.payload?.status) {
          error_msg = result?.payload?.errors?.category?.[0];
        } else {
          error_msg = "An unknown error occurred.";
        }

        const updatedData = allAccounts?.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              approval_status:
                item.approval_status === "pending" ? "error" : "pending",
              rejected_on: "",
              rejected_by_name: "",
              rejection_reason: AccountIdData,
              error: "true",
              message: error_msg,
              pending_transactions: "N",
              pending_scheduled_transactions: "N",
            };
          }
          return item;
        });

        updateAllAccounts(updatedData);

        setShowLoader(false);
        setShowPopup(false);
        setDeclineReason("");
        onClose();
        CommonToast({
          text: error_msg,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      } else {
        const updatedData = allAccounts.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              approval_status: "rejected",
              rejected_on:
                result?.payload?.beneficiary_accounts?.[0]?.rejected_on ?? "",
              rejected_by_name:
                result?.payload?.beneficiary_accounts?.[0]?.rejected_by_name ??
                "",
              rejection_reason: AccountIdData,
              error: "false",
              message: "",
            };
          }
          return item;
        });

        updateAllAccounts(updatedData);
        setShowLoader(false);
        setDeclineReason("");
        setAssociateType("");
        onClose();
        setShowPopup(false);
        CommonToast({
          text: "Account rejected successfully.",
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }
    }
  };

  const convertDate = (dateString) => {
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration.intervalMedium,
    );
    return timestamp;
  };

  // Reject benificiary transactions
  const handleRejectBeneTxn = async () => {
    setShowLoader(true);

    const AccountIdData = declineReason;
    let id2 = [];

    id2 =
      !beneTxnViewAllAccLoading &&
      beneTxnViewAllAccData?.transactions?.length >
        GlobalConfiguration.lengthCheckZero
        ? beneTxnViewAllAccData?.transactions.map((data) => data?.txn_id)
        : [];

    UniversalRefreshToast("Rejecting transaction");

    let data = null;

    if (id2.length > GlobalConfiguration.lengthCheckZero) {
      data = await dispatch(
        beneTxnMultiDeniedApproval({ id: id2, AccountIdData }),
      );
    } else {
      data = { payload: { status: true } };
    }

    if (
      data?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration.lengthCheckZero
    ) {
      const serviceKey = "ABeneficiaryTxn";

      navigate("/feature_not_assigned", {
        state: { unavailableService: serviceKey },
      });
      return;
    }

    await new Promise((resolve) =>
      setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
    );

    if (data?.payload?.status === false) {
      const error_msg = data?.payload?.errors?.user_unauthorized
        ? data?.payload?.errors?.user_unauthorized[0]
        : Array.isArray(data?.payload?.errors?.base) &&
            Array.isArray(data?.payload?.errors?.base[0]?.errors)
          ? data.payload.errors.base[0].errors[0]
          : data?.payload?.errors?.base?.[0] || "Unknown error occurred";
      CommonToast({
        text: error_msg,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });

      setShowLoader(false);
    } else if (data?.payload?.status === true) {
      setShowRejectPopup(false);
      CommonToast({
        text: "Transaction Rejected successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      const updatedData = allAccounts?.map((item) => {
        if (item.id === associatePopupDate?.accId) {
          return {
            ...item,
            pending_transactions: "N",
          };
        }
        return item;
      });

      if (associateType === "rejectAccount") {
        allAccounts?.forEach((item) => {
          if (item.id === associatePopupDate?.accId) {
            if (item?.pending_scheduled_transactions === "Y") {
              setTimeout(() => {
                setShowScheduleTxnPopup(true);
              }, IntervalConfiguration.intervalMedium);
            } else {
              handleConfirm(deniedId, declineReason);
            }
          }
        });
      }

      updateAllAccounts(updatedData);
    } else if (data?.payload === undefined) {
      CommonToast({
        text: "An error occurred while taking action on this account",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
    setTimeout(() => {
      setShowRejectPopup(false);
    }, IntervalConfiguration.intervalMedium);
    if (associateType !== "rejectAccount") {
      setDeclineReason("");
      setAssociateType("");
    }
    setShowLoader(false);
    setShowPopup(false);
  };

  const handleRejectScheduleTxn = async () => {
    const AccountIdData = declineReason;

    let id2 =
      !schedulesTxnViewAllLoading &&
      schedulesTxnViewAllData?.transactions?.length >
        GlobalConfiguration.lengthCheckZero
        ? schedulesTxnViewAllData?.transactions.map((data) => data?.txn_id)
        : [];
    if (id2.length > GlobalConfiguration.lengthCheckZero) {
      let data2 = await dispatch(
        schedulesTxnReject({
          id: id2,
          reason: AccountIdData,
          services,
        }),
      );
      if (data2?.payload?.status === false) {
        const error_msg2 = data2?.payload?.errors?.user_unauthorized
          ? data2?.payload?.errors?.user_unauthorized[0]
          : Array.isArray(data2?.payload?.errors?.base) &&
              Array.isArray(data2?.payload?.errors?.base[0]?.errors)
            ? data2.payload.errors.base[0].errors[0]
            : data2?.payload?.errors?.base?.[0] || "Unknown error occurred";
        CommonToast({
          text: error_msg2,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });

        setTimeout(() => {
          setShowScheduleTxnPopup(false);
        }, IntervalConfiguration.intervalMedium);

        setShowLoader(false);
      } else if (data2?.payload?.status === true) {
        setShowScheduleTxnPopup(false);
        CommonToast({
          text: "Scheduled transactions rejected successfully.",
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });

        setTimeout(() => {
          setShowScheduleTxnPopup(false);
        }, IntervalConfiguration.intervalMedium);

        const updatedData = allAccounts?.map((item) => {
          if (item.id === associatePopupDate?.accId) {
            return {
              ...item,
              pending_scheduled_transactions: "N",
            };
          }
          return item;
        });

        updateAllAccounts(updatedData);
        if (associateType === "rejectAccount") {
          handleConfirm(deniedId, declineReason);
        }
      }
      setDeclineReason("");
      setAssociateType("");
      setShowPopup(false);
    }
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setAllBeneTxnAccountsLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds = toArray(lebalid);
    const res = await dispatch(
      addNewLabel({ record_ids: recordIds, labels: labelsToAssign }),
    );
    if (addNewLabel?.fulfilled?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (addNewLabel?.rejected?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.INFO_FILLED,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setAllBeneTxnAccountsLoading(false);
    if (addNewLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setAllBeneTxnAccountsLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(lebalid);
    const res = await dispatch(
      removeNewLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );
    if (removeNewLabel?.fulfilled?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (removeNewLabel?.rejected?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.INFO_FILLED,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setAllBeneTxnAccountsLoading(false);
    if (removeNewLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  return (
    <>
      {openBeneAssociate && (
        <div onClick={(e) => e.stopPropagation()}>
          <BeneAccountViewAllPopup
            onClose={handleCloseModal}
            onAccountSelect={(name, bankAccNo, ifscCode) => {
              handleCloseModal();
            }}
            associateAccount={true}
            associatepanNumber={associatePopupDate?.panNumber}
            associateIFSC={associatePopupDate?.ifscCode}
            associateaccountNumber={associatePopupDate?.accNumber}
            beneAccountId={associatePopupDate?.accId}
            accountType={"beneficiary"}
            flow={"beneTxn"}
            ispanbankRequired={true}
            setOpenBeneAssociate={setOpenBeneAssociate}
            activeType={activeType}
            setActiveType={setActiveType}
            setRemPan={setRemPan}
            setRemAccount={setRemAccount}
            setRemIFSC={setRemIFSC}
            remPan={remPan}
            remAccount={remAccount}
            remIFSC={remIFSC}
            typePanBank={"BeneAccPanBankSwitch"}
            onCardNavigate={handleCardClick}
          />
        </div>
      )}

      {isalertPopup && (
        <div
          className="fixed z-z-index-max flex items-center justify-center top-left-base left-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={(e) => e.stopPropagation()}
        >
          <SmallPopup
            headerTitle="Open in full view?"
            headerFontWeight="semibold"
            headerFontColor="emphasis"
            textSize="font-lg"
            subtext="Leaving this page will exit you from current flow."
            btnOneText="Cancel"
            btnOneHandleFunction={handleAlertCancel}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Leave"
            btnTwoHandleFunction={handleLeaveConfirm}
            btnTwoEnabledBgColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--primary-bg)"
            btnTwoIsDisabled={false}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={true}
            btnTwoHoverOption="black"
          />
        </div>
      )}

      {isLabelPopupOpen && (
        <div
          onClick={() => {
            setIsLabelPopupOpen(false);
          }}
          className="fixed left-left-base w-width-full top-top-base h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex"
          max-zindex
        >
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated accounts."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            LabelAccounts={lebalid}
            isLabelPopupOpen={isLabelPopupOpen}
            filteredData={(filteredData || []).filter((acc) =>
              Array.isArray(lebalid)
                ? lebalid.includes(acc?.id)
                : lebalid === acc?.id,
            )}
            loading={allBeneTxnAccountsLoading}
            setLoading={setAllBeneTxnAccountsLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
          />
        </div>
      )}

      {showRejectPopup && (
        <LargePopupRedirect
          headerTitle="Associated transactions found"
          headersubtext="The following transactions are linked and need to be rejected before rejecting this account."
          closeiconenabledBgColor="var(--primary-nav)"
          closeiconisLoading={false}
          closeiconhandleFunction={() => setShowRejectPopup(false)}
          closeicon={ICONS?.CLOSE}
          closeiconhoverOption="white"
          closeiconbtnType={"button"}
          closeiconisDisabled={false}
          closeicondisabledBgColor={""}
          closeiconbuttonRef={null}
          closeicontitle={"Close"}
          btnType={"button"}
          bottomHeaderTextNeed={true}
          bottomHeaderText={
            "To reject the account, please reject the transactions listed above by clicking the “Reject all” button. The transactions will get rejected with the provided rejected reason."
          }
          isbottomSectionneed={true}
          btnText={"Reject all"}
          confirmbtnrequired={true}
          handleFunction={() => {
            if (associateType === "BeneTxn") {
              setShowPopup(true);
            } else {
              handleRejectBeneTxn();
            }
          }}
          enabledBgColor={"var(--negative-act)"}
          hoverOption={"dark"}
          outLineColor={""}
          enabledTextColor={"var(--text-primary)"}
          fullWidthRequired={false}
          isDisabled={false}
          disabledTextColor={""}
          disabledBgColor={""}
        >
          <BeneficiaryTransactionViewall
            bene_account_id={associatePopupDate?.accId}
            typepop={"BeneAccRejectTxn"}
            closeRejectAllTxn={handleClosePopup}
            bene_account_name={associatePopupDate?.accName}
          />
        </LargePopupRedirect>
      )}

      {showScheduleTxnPopup && (
        <LargePopupRedirect
          headerTitle="Associated schedules found"
          headersubtext="The following schedules are linked and need to be rejected before rejecting this account."
          closeiconenabledBgColor="var(--primary-nav)"
          closeiconisLoading={false}
          closeiconhandleFunction={() => setShowScheduleTxnPopup(false)}
          closeicon={ICONS?.CLOSE}
          closeiconhoverOption="white"
          closeiconbtnType={"button"}
          closeiconisDisabled={false}
          closeicondisabledBgColor={""}
          closeiconbuttonRef={null}
          closeicontitle={"Close"}
          btnType={"button"}
          bottomHeaderTextNeed={true}
          bottomHeaderText={
            "To reject the account, please reject the schedules listed above by clicking the “Reject all” button. The schedules will get rejected with the provided rejected reason."
          }
          isbottomSectionneed={true}
          btnText={"Reject all"}
          confirmbtnrequired={true}
          handleFunction={() => {
            if (associateType === "scheduleBeneTxn") {
              setShowPopup(true);
            } else {
              handleRejectScheduleTxn();
            }
          }}
          enabledBgColor={"var(--negative-act)"}
          hoverOption={"dark"}
          outLineColor={""}
          enabledTextColor={"var(--text-primary)"}
          fullWidthRequired={false}
          isDisabled={false}
          disabledTextColor={""}
          disabledBgColor={""}
        >
          <ScheduleBeneficiaryTransactionViewSchedules
            type={"ScheduleAccBeneAcc"}
            payload={{
              schedule_acc_id: associatePopupDate?.accId,
              schedule_acc_name: associatePopupDate?.accName,
            }}
            closeCallback={handleClosePopup}
          />
        </LargePopupRedirect>
      )}

      {/* Popup for entering reason for declining account & transaction */}
      {showPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-max-zindex bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <SmallPopupWithInput
            headerTitle="Rejected reason"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle="Please state the reason for rejecting the account."
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-xs"
            noteColor="text-secondary"
            inputPlaceholder="Reason (10-150 char)"
            inputVariant={computeVariant(declineReason, isFocused)}
            inputOnFocus={(e) => setIsFocused(true)}
            inputOnBlur={(e) => setIsFocused(false)}
            btnOneIsDisabled={showLoader ? true : false}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (!showLoader) {
                handleInputChange(e);
              }
            }}
            inputValue={declineReason}
            inputFontKind="small"
            inputIsFullWidth={true}
            btnOneText="Cancel"
            btnOneHandleFunction={() => {
              setWhichBtnClicked((p) => {
                return {
                  ...p,
                  [deniedId]: "none",
                };
              });
              handleClosePopup();
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnTwoText="Reject"
            btnTwoHandleFunction={() => {
              if (associateType === "scheduleBeneTxn") {
                handleRejectScheduleTxn();
              } else if (associateType === "BeneTxn") {
                handleRejectBeneTxn();
              } else {
                handleRejectTransactionChecker(deniedId, declineReason);
              }
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              !declineReason ||
              declineReason.trim().length < 10 ||
              declineReason.trim().length > 150
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={showLoader ? true : false}
            btnTwoIsLoading={showLoader ? true : false}
            btnTwoHoverOption="black"
            btnTwoInActiveVariantNeeded={true}
          />
        </div>
      )}

      {/* Account details in a modal */}
      {isDrawerOpen && (
        <BeneAccountDetailsPopup
          closeBeneAccountDetailModal={closeBeneAccountDetailModal}
          bene_account_id={BeneTxnDetailsId}
          type={"bene_account_detail_modal"}
          showCategory={showCategory}
        />
      )}

      {/* Entire page */}
      <div className="h-screen overflow-hidden flex flex-col">
        <div className="relative z-z-index-overlay bg-primary-nav min-h-height-base Qmd:min-h-navbar-breadcrumb-height"></div>

        <div className=" w-full relative z-z-index-header lg:px-padding-base flex items-center justify-end m-auto">
          <TopNavComponent
            filteredSearchProps={{
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isSearchDisabled: allBeneTxnAccountsLoading,
              onSearchInput: handleSearch,
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search beneficiary account",
              filterPlaceholder:
                "name / contact number / email ID / account ID",
              filterItems: [
                {
                  name: "Search",
                  isMulti: false,
                  value: searchUserText,
                  setValue: setSearchUserText,
                  isDropdown: false,
                  isDisabled: false,
                },
                {
                  name: "Account number",
                  short_name: "Bene. Acc",
                  isMulti: false,
                  value: accountNumber,
                  setValue: setAccountNumber,
                  isDropdown: false,
                  valueType: "string",
                  isDisabled: false,
                },
                {
                  name: "IFSC code",
                  short_name: "IFSC",
                  isMulti: false,
                  value: isIfsc.toUpperCase(),
                  setValue: setIsIfsc,
                  valueType: "string",
                  isDropdown: false,
                  isDisabled: false,
                },
                {
                  name: "PAN number",
                  short_name: "PAN",
                  isMulti: false,
                  value: panNumber.toUpperCase(),
                  setValue: setPanNumber,
                  valueType: "string",
                  isDropdown: false,
                  isDisabled: false,
                },
                {
                  name: "Category",
                  valueType: "string",
                  short_name: "Cat",
                  isMulti: false,
                  value: currentCategory,
                  setValue: setCurrentCategory,
                  isDropdown: true,
                  isDisabled: false,
                },
                {
                  name: "Labels",
                  short_name: "Lab",
                  isMulti: true,
                  value: LabelSearchText,
                  setValue: setLabelSearchText,
                  isDropdown: true,
                  valueType: "string",
                  isDisabled: false,
                },
              ],
              filters: [
                {
                  name: "Date range",
                  filterType: "calender",
                  variant: "range",
                  size: "small",
                  value: startDateFilter && endDateFilter,
                  isDisable: false,
                  startDate: startDateFilter
                    ? new Date(
                        startDateFilter * IntervalConfiguration.intervalMedium,
                      )
                    : startDateFilter,
                  endDate: endDateFilter
                    ? new Date(
                        endDateFilter * IntervalConfiguration.intervalMedium,
                      )
                    : endDateFilter,
                  handleChange: (date) => handleDateChange(date),
                },
              ],
              isFilterClearAllDisabled: !(startDateFilter && endDateFilter),
              isSearchClearAllDisabled: !(
                currentCategory !== "" ||
                panNumber !== "" ||
                LabelSearchText?.length !==
                  GlobalConfiguration.lengthCheckZero ||
                isIfsc !== "" ||
                searchUserText !== "" ||
                accountNumber !== ""
              ),

              inputData: inputData,
              active: active,
              setActive: setActive,
              loading: allBeneTxnAccountsLoading,
              setLoading: (e) => {},
              isSortDisabled: allBeneTxnAccountsLoading,
              isFilterDisabled: allBeneTxnAccountsLoading,
              isShowFilter: true,
            }}
          />
        </div>
        <div
          style={{
            marginBottom: showInnerSearchBar ? "" : "var(--pagination-height)",
          }}
          className={`flex-1 flex flex-col overflow-hidden relative ${showInnerSearchBar ? "pointer-events-none" : ""}`}
        >
          {showInnerSearchBar && (
            <div className="absolute bg-PopUp-BackDrop bg-opacity-dark-opacity pointer-events-none w-full h-full z-z-index-content"></div>
          )}
          <div
            style={{
              paddingBottom:
                beneRequiredApprovalData?.summary?.pending_accounts_count ===
                  undefined && "var(--padding-md)",
            }}
            className={`flex flex-col flex-1 items-center overflow-auto overflow-x-hidden w-full pb-padding-lg bg-primary-bg ${allBeneTxnAccountsLoading ? "h-full" : ""} `}
          >
            {allBeneTxnAccountsLoading ? (
              <div className="loader-container m-auto justify-center items-center flex">
                <Loader />
              </div>
            ) : noResultsAfterFilter ? (
              <div className="flex flex-col items-center justify-center m-auto w-full h-full">
                <img
                  src={ICONS?.NO_DATA_FOUND}
                  alt="No accounts found"
                  className={"w-graphic-width-md h-graphic-rectangle-height-md"}
                />
                <p className="bene-acc-no-beneaccount-text my-margin-sm">
                  No data found.
                </p>

                <PrimaryButton
                  enabledBgColor="var(--primary-nav-act)"
                  btnText="Clear parameters"
                  btnType="button"
                  handleFunction={handleClearFilters}
                  enabledTextColor="var(--text-primary)"
                />
              </div>
            ) : allAccounts?.length > GlobalConfiguration.lengthCheckZero ? (
              <div
                className="scroll flex flex-col items-center justify-center w-width-full"
                ref={filterRef}
              >
                <div className="scroll flex flex-col items-center justify-center w-width-full lg:w-auto px-padding-md lg:px-padding-base gap-gap-md">
                  {allAccounts?.map((account, index) => {
                    const buildAlerts = () => [
                      ...(account?.all_category_assign === "Y"
                        ? [
                            {
                              isLoading: false,
                              text: "All categories are assigned to this account",
                              icon: ICONS?.ALERT,
                              onClick: () => {
                                BeneAccountMoreDetailsPopup(account.id);
                                setShowCategory(true);
                              },
                            },
                          ]
                        : []),

                      ...(account?.associate_bank === "Y" ||
                      account?.associate_pan === "Y"
                        ? [
                            {
                              isLoading: false,
                              text: "Associated accounts are found",
                              icon: ICONS?.ALERT,
                              onClick: () => {
                                openAssociatedAccountsFound(
                                  account?.ifsc_code,
                                  account?.bank_acc_no,
                                  account?.pan_no,
                                  account?.id,
                                );
                              },
                            },
                          ]
                        : []),

                      ...(account?.pending_beneficiary_transactions === "Y"
                        ? [
                            {
                              isLoading: false,
                              text: "Pending transactions found",
                              icon: ICONS?.ALERT,
                              onClick: () => {
                                openTxnPopup(account?.id, account?.name);
                                setShowRejectPopup(true);
                                setAssociateType("BeneTxn");
                                setAccountName(account?.name);
                              },
                            },
                          ]
                        : []),

                      ...(account?.pending_scheduled_beneficiary_transactions ===
                      "Y"
                        ? [
                            {
                              isLoading: false,
                              text: "Pending schedules found",
                              icon: ICONS?.ALERT,
                              onClick: () => {
                                openTxnPopup(account?.id, account?.name);
                                setShowScheduleTxnPopup(true);
                                setAssociateType("scheduleBeneTxn");
                                setAccountName(account?.name);
                              },
                            },
                          ]
                        : []),
                    ];
                    return (
                      <div
                        key={account.id}
                        className={`w-full ${index === 0 ? "mt-margin-md" : ""}`}
                      >
                        <CommonAccountApprovalCard
                          overrideAutoLoader
                          whichBtnClicked={
                            whichBtnClicked?.[account?.id] ?? "none"
                          }
                          entries={[
                            [
                              {
                                type: "textSubtext",
                                text: accountNameStandardised(account.name),
                                subText: "Account name",
                              },
                              {
                                type: "textSubtext",
                                text: account.email_id,
                                subText: "Email ID",
                              },
                              {
                                type: "textSubtext",
                                text: "+91 " + account.contact_no,
                                subText: "Contact number",
                              },
                              {
                                type: "textSubtext",
                                text: "Pending",
                                subText: "Account type",
                              },
                            ],

                            [
                              {
                                type: "textSubtext",
                                text: accountNameStandardised(
                                  account.bank_account_holder_full_name,
                                ),
                                subText: "Bank account holder name ",
                              },
                              {
                                type: "accountNumber",
                                text: account.bank_acc_no,
                                subText: "Account number",
                                ifsc: account.ifsc_code,
                              },
                              {
                                type: "textSubtext",
                                text: account.ifsc_code,
                                subText: "IFSC code",
                              },
                              {
                                type: "textSubtextX2",
                                text: account.pan_no,
                                subText: "PAN number",
                                text1: account.gstin_detail || "Not given",
                                subText1: "GSTIN",
                              },
                            ],

                            [
                              {
                                type: "cta",
                                text:
                                  account?.labels?.join(", ") ||
                                  "No labels assigned",
                                subText: "Assigned labels",
                                onClick: (e) => {
                                  if (
                                    services?.includes("ALabel") &&
                                    services?.includes("RLabel")
                                  ) {
                                    e.stopPropagation();
                                    setlableid(account?.id);
                                    setIsLabelPopupOpen(true);
                                  } else {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "ALabel,RLabel",
                                      },
                                    });
                                  }
                                },
                              },
                              {
                                type: "textSubtext",
                                text: account?.category || "Not Assigned",
                                subText: "Assigned categories",
                              },
                            ],
                          ]}
                          approveClick={() => {
                            setWhichBtnClicked((p) => {
                              return {
                                ...p,
                                [account?.id]: "approve",
                              };
                            });
                            handleApproval(account.id);
                          }}
                          rejectClick={() => {
                            setWhichBtnClicked((p) => {
                              return {
                                ...p,
                                [account?.id]: "reject",
                              };
                            });
                            handleOpenPopup(account?.id);
                            openTxnPopup(account?.id, account?.name);
                            setAssociateType("rejectAccount");
                          }}
                          ctaBtn1Text={"More details"}
                          ctaBtn1OnClick={
                            account.approval_status === "pending" &&
                            !loading[account.id]
                              ? () => {
                                  BeneAccountMoreDetailsPopup(account.id);
                                  setShowCategory(false);
                                }
                              : undefined
                          }
                          cardState={
                            account.approval_status === "Approved" &&
                            account.error === "false" &&
                            beneWaitingApprovalData &&
                            !loading[account.id]
                              ? "single"
                              : account.approval_status === "rejected" &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? account.rejection_reason
                                  ? "double"
                                  : "single"
                                : account.approval_status === "error" &&
                                    account.error === "true" &&
                                    !loading[account.id]
                                  ? "single"
                                  : "default"
                          }
                          overlay1Text={
                            account.approval_status === "Approved" &&
                            account.error === "false" &&
                            beneWaitingApprovalData &&
                            !loading[account.id]
                              ? "Approved"
                              : account.approval_status === "rejected" &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? "Rejected"
                                : account.approval_status === "error" &&
                                    account.error === "true" &&
                                    !loading[account.id]
                                  ? "Failed to take action!"
                                  : undefined
                          }
                          overlay1Subtext={
                            account.approval_status === "Approved" &&
                            account.error === "false" &&
                            beneWaitingApprovalData &&
                            !loading[account.id]
                              ? "This account has been approved."
                              : account.approval_status === "rejected" &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? "This account has been rejected."
                                : account.approval_status === "error" &&
                                    account.error === "true" &&
                                    !loading[account.id]
                                  ? account.message ||
                                    "An error occurred while taking action on this account."
                                  : undefined
                          }
                          overlay1Icon={
                            account.approval_status === "Approved" &&
                            account.error === "false" &&
                            beneWaitingApprovalData &&
                            !loading[account.id]
                              ? ICONS?.APPROVED_GREEN_LINEAR
                              : account.approval_status === "rejected" &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? ICONS?.REJECTED_RED
                                : account.approval_status === "error" &&
                                    account.error === "true" &&
                                    !loading[account.id]
                                  ? ICONS?.ERROR_WITH_WHITE_OUTLINED_CIRCLE
                                  : undefined
                          }
                          overlay1CtaText={
                            (account.approval_status === "Approved" &&
                              account.error === "false" &&
                              beneWaitingApprovalData &&
                              !loading[account.id]) ||
                            (account.approval_status === "error" &&
                              account.error === "true" &&
                              !loading[account.id]) ||
                            (account.approval_status === "rejected" &&
                              account.error === "false" &&
                              !loading[account.id])
                              ? "View account"
                              : undefined
                          }
                          overlay1CtaOnClick={
                            (account.approval_status === "Approved" &&
                              account.error === "false" &&
                              beneWaitingApprovalData &&
                              !loading[account.id]) ||
                            (account.approval_status === "error" &&
                              account.error === "true" &&
                              !loading[account.id]) ||
                            (account.approval_status === "rejected" &&
                              account.error === "false" &&
                              !loading[account.id])
                              ? () => {
                                  BeneAccountMoreDetailsPopup(account.id);
                                  setShowCategory(false);
                                }
                              : undefined
                          }
                          overlay1CtaInactive={false}
                          overlay1CtaDisabled={loading[account.id]}
                          overlay1CtaLoading={loading[account.id]}
                          overlay2Text={
                            account.approval_status === "rejected" &&
                            account.error === "false" &&
                            !loading[account.id]
                              ? account.rejection_reason
                              : undefined
                          }
                          overlay2Subtext={
                            account.approval_status === "rejected" &&
                            account.error === "false" &&
                            !loading[account.id]
                              ? "Rejected reason"
                              : undefined
                          }
                          alerts={buildAlerts()}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : noTransactionsFromAPI ? (
              <div className="BeneAccount_NoAccountFound">
                <div className="BeneAccount_RightTextContentNoAccount">
                  <img
                    src={ICONS?.NO_PENDING_TRANSACTION}
                    alt=""
                  />
                </div>

                <div className="BeneAccount_LeftTextContentNoAccount_acc">
                  <p>There are no more accounts that</p>
                  <p>require your approval.</p>

                  <button
                    className="bene-acc-home-dashboard-btn"
                    onClick={() => navigate("/beneficiary_account_dashboard")}
                  >
                    Beneficiary account dashboard
                  </button>
                </div>
              </div>
            ) : null}
          </div>
          {!allBeneTxnAccountsLoading &&
            !noResultsAfterFilter &&
            !noTransactionsFromAPI && (
              <div
                className={`w-width-full bottom-bottom-base fixed ${
                  accumulatedData?.length ===
                    GlobalConfiguration.lengthCheckZero &&
                  filteredData?.length ===
                    GlobalConfiguration.lengthCheckZero &&
                  !loading
                    ? "hidden"
                    : "block"
                } ${isSidebarOpen ? " z-z-index-base" : " z-z-index-content"}`}
              >
                {showInnerSearchBar && (
                  <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
                )}
                <div
                  className={`${(isSidebarOpen || showInnerSearchBar) && "  pointer-events-none"}`}
                >
                  <PaginationComponent
                    handleSelect={handleSelect}
                    selectedValue={selectedValue}
                    data={mainData}
                    pageSize={pageSize}
                    dropdownOptions={dropdownOptions}
                    handlePagination={handlePagination}
                    currentPage={currentPage}
                    setIsOpen={setIsOpen}
                  />
                </div>
              </div>
            )}
        </div>
      </div>
    </>
  );
};

export default BeneficiaryAcountApproval;
